<script setup>
import ModalSimple from '@/components/ModalSimple.vue';
import { isEmpty, sortBy } from 'lodash';
import {
  computed, nextTick, ref, watch,
} from 'vue';
import draggable from 'vuedraggable';

const props = defineProps({
  opcionValoresIniciales: { type: Array, required: true },
});
const opcionValores = ref(props.opcionValoresIniciales);
const showModal = ref(false);
const inputValor = ref();
const valorDelInput = ref();

// Objeto opcionValor que está en el modal con el formulario de añadir o editar
const opcionValorFormulario = ref({});

const opcionValoresOrdenados = computed(() => sortBy(opcionValores.value, 'orden'));

watch(opcionValorFormulario, () => {
  valorDelInput.value = opcionValorFormulario.value.valor;
});

function getOpcionValorByValor(valor) {
  return opcionValores.value.find((ov) => ov.valor === valor);
}

function mostrarModal() {
  showModal.value = true;
  nextTick(() => {
    inputValor.value.focus();
  });
}

function ocultarModal() {
  opcionValorFormulario.value = {};
  showModal.value = false;
}

function nuevoValor() {
  opcionValorFormulario.value = { id: null, valor: null, nuevo: true };
  mostrarModal();
}

function editarValor(valor) {
  opcionValorFormulario.value = getOpcionValorByValor(valor);
  mostrarModal();
}

function aceptarValor(valor) {
  const opcionExiste = getOpcionValorByValor(valor);
  // Ya hay otra opción con ese valor, ignoramos
  if (opcionExiste) {
    ocultarModal();
    return;
  }

  opcionValorFormulario.value.valor = valor;

  if (opcionValorFormulario.value.nuevo) {
    opcionValorFormulario.value.nuevo = false;
    opcionValores.value.push(opcionValorFormulario.value);
  }
  ocultarModal();
}

function quitarValor(valor) {
  opcionValores.value.splice(opcionValores.value.indexOf(getOpcionValorByValor(valor)), 1);
}

function actualizarOrden(lista) {
  let orden = 1;
  lista.forEach((ov) => {
    ov.orden = orden;
    orden += 1;
  });
}
</script>

<template>
  <div>
    <input type="hidden" name="json_opcion_valores" :value="JSON.stringify(opcionValores)">
    <div class="subtitulo-seccion">
      {{ $t('Valores') }}
      <button type="button" class="btn btn-sm btn-cifra pull-right" @click="nuevoValor()">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <table class="table">
      <tbody v-if="isEmpty(opcionValores)">
        <tr>
          <td>{{ $t('Sin_opciones') }}</td>
        </tr>
      </tbody>
      <draggable
        v-else
        :model-value="opcionValoresOrdenados"
        tag="tbody"
        item-key="valor"
        handle=".icono-ordenar"
        class="draggable"
        @update:model-value="actualizarOrden($event)"
      >
        <template #item="{ element }">
          <tr>
            <td class="col-min">
              <i class="icono-ordenar fa fa-bars"></i>
            </td>
            <td :data-id="element.id">
              {{ element.valor }}
            </td>
            <td class="col-min">
              <i
                class="fa fa-edit clickable m-r-xs"
                @click="editarValor(element.valor)"
              >
              </i>
              <i
                class="fa fa-trash text-danger clickable"
                @click="quitarValor(element.valor)"
              >
              </i>
            </td>
          </tr>
        </template>
      </draggable>
    </table>
    <ModalSimple
      v-model="showModal"
      :titulo="$t('valor')"
    >
      <form @submit.prevent="aceptarValor(valorDelInput)">
        <input
          ref="inputValor"
          v-model="valorDelInput"
          type="text"
          class="form-control"
        >
        <div class="form-actions m-t">
          <button type="submit" class="btn btn-cifra">
            {{ $t('Aceptar') }}
          </button>
        </div>
      </form>
    </ModalSimple>
  </div>
</template>
<style scoped>
  .icono-ordenar {
    cursor: pointer;
  }
</style>
